import * as actionTypes from '../actions/actionTypes';

export const agGridInitialState = {
  dataPerTableName: {}
};
const reducer = (state = agGridInitialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_AG_GRID_STATE:
      return {
        ...state,
        dataPerTableName: {
          ...state.dataPerTableName,
          ...action.tableTypeData
        }
      };
    default:
      return state;
  }
};

export default reducer;
